// Conti della schermata «Oggi»: quanto sono pieni i lettini e quali sono i prossimi trattamenti (coppia = una voce).
import { SALE, LETTINI, START, END, toMin, fine, occupa } from './agenda.js';

/** Percentuale dei lettini occupati nell'orario della SPA (6 lettini × 10:30–19:00), arrotondata. */
export function occupazione(prenotazioni) {
  const totale = SALE.length * LETTINI.length * (END - START);
  const usati = prenotazioni.filter(occupa)
    .reduce((x, b) => x + Math.max(0, Math.min(fine(b), END) - Math.max(toMin(b.inizio), START)), 0);
  return Math.round((usati / totale) * 100);
}

/**
 * Prossimi trattamenti: quelli attivi non ancora finiti, in ordine di ora (poi sala e lettino).
 * La coppia diventa una voce sola: { b: lettino più basso, partner: l'altra persona }.
 * @param {number} minuti ora attuale in minuti (0 = mostra tutto il giorno)
 * @returns {Array<{ b: object, partner: object|null }>}
 */
export function prossimi(prenotazioni, minuti, quanti = 5) {
  const attivi = prenotazioni.filter((b) => occupa(b) && fine(b) > minuti)
    .sort((a, b) => toMin(a.inizio) - toMin(b.inizio) || a.sala.localeCompare(b.sala) || a.lettino - b.lettino);
  const presi = new Set();
  const voci = [];
  for (const b of attivi) {
    if (presi.has(b.id)) continue;
    const partner = b.coppia ? attivi.find((o) => o.coppia === b.coppia && o.id !== b.id) || null : null;
    if (partner) presi.add(partner.id);
    voci.push({ b, partner });
  }
  return voci.slice(0, quanti);
}
